import axios from 'axios';
import { getURLParameters } from './params';
import { trackEvent } from './index';
import { fireLogWithSentry } from './sentry';
import { KEY_MAPPINGS } from './keyMappings';
import { ANALYTICS_BASE_URL, DOM_LOADED_DELAY } from './constants';

export const events = [];

/**
 * find "HTMLElement" those have analytic attributes
 * @param {HTMLElement} element
 * @returns {HTMLElement}
 */
const findAnalyticsAttribute = (element: HTMLElement) => {
   if (!element) return null;
   let attribute = null;
   try {
      attribute =
         element.getAttribute('data-analytics') ||
         (element.dataset && element.dataset.analytics);
      if (attribute) return attribute;
      else {
         const parent = element.parentElement;
         return findAnalyticsAttribute(parent);
      }
   } catch (error) {
      fireLogWithSentry(
         'functions.ts-->findAnalyticsAttribute--error occurred in clickstream sdk:',
         error
      );
   }
   return attribute;
};

/**
 * if "HTMLElement" have data-analytics attribute
 * then it can listen for click listeners
 */
export const initClickEventListener = () => {
   try {
      document.addEventListener(
         'click',
         function (event: Event) {
            event = event || window.event;
            const target = event.target as HTMLElement;
            let attributes = findAnalyticsAttribute(target);
            if (!attributes) {
               return;
            } else {
               attributes = JSON.parse(attributes);
               trackEvent(attributes);
            }
         },
         false
      );
   } catch (error) {
      fireLogWithSentry(
         'functions.ts-->trackEvent-->error occurred in clickstream sdk:',
         error
      );
   }
};

/**
 * generate url with all the analytics data
 * @param {string} baseUrl
 * @param {object} params
 * @returns {string}
 */
const generateUrlWithParams = (baseUrl, params) => {
   let paramString = '';
   let url = '';

   for (const key in params) {
      if (Object.hasOwnProperty.call(params, key) && KEY_MAPPINGS[key]) {
         paramString += `${KEY_MAPPINGS[key]}=${params[key]}&`;
      }
   }

   url = encodeURI(`${baseUrl}${paramString}`);
   return url;
};

/**
 * callback handler to make network reqest to backend
 * @param {object} params
 */
const submitAnalytics = (params) => {
   try {
      //getting default dimensions (to be captured by sdk only )
      const urlParameters = getURLParameters(params);

      //adding global and custom dimensions to urlParameters
      if (params != null) {
         for (const key in params) {
            //this also overrides any default dimension if passed by frontend
            if (key && Object.hasOwnProperty.call(KEY_MAPPINGS, key))
               urlParameters[key] = params[key];
         }
      }
      const url = generateUrlWithParams(ANALYTICS_BASE_URL, urlParameters);
      axios({ method: 'GET', url, timeout: params['timeout'] });
   } catch (error) {
      fireLogWithSentry(
         'functions.ts-->submitAnalytics-->error occurred in clickstream sdk:',
         error
      );
   }
};

/**
 * fireEvent once document is fully loaded
 */
export const fireEvent = () => {
   events.forEach((params) => submitAnalytics(params));
   events.length = 0;
};
